import { Navigate } from 'react-router-dom';
import { requireModule } from 'auth/guards';
import { MODULES } from 'auth/permissions';
import { AdminVouchersSection, MyVouchersSection } from './sections';

/**
 * Reimbursements, split by who uses it (V30): everyone raises and follows their own claims on
 * My Reimbursements; approvers work the queue under Billing → Reimbursement.
 */
export const vouchersRoutes = [
  {
    path: '/my-reimbursements',
    loader: requireModule(MODULES.REIMBURSEMENTS),
    handle: { breadcrumb: 'My Reimbursements' },
    element: <MyVouchersSection />,
  },
  {
    path: '/reimbursement-approvals',
    loader: requireModule(MODULES.REIMBURSEMENT_APPROVALS),
    handle: { breadcrumb: 'Reimbursement' },
    element: <AdminVouchersSection />,
  },
  // The old combined page.
  { path: '/vouchers', element: <Navigate to='/my-reimbursements' replace /> },
];
